<template>
  <base-dialog
    v-model="show"
    height="300px"
    :title="$t('avatar.title')"
    width="400px"
  >
    <div id="app" style="height: 400px; display: flex">
      <cropper
        v-if="img"
        class="cropper"
        :src="img"
        :stencilProps="{ aspectRatio: 10 / 12 }"
        @change="change"
      ></cropper>
      <div v-else class="avatar_null" @click="goUpload">
        <div>
          Chọn ảnh đại diện
        </div>



        <!-- drag and drop photos -->
        <div
          :class="['dropZone', dragging ? 'dropZone-over' : '']"
          @dragenter="dragging = true"
          @dragleave="dragging = false"
        >
          <div class="dropZone-info" @drag="onChange">
            <span class="fa fa-cloud-upload dropZone-title"></span>
            <span class="dropZone-title"
              >Hoặc kéo file vào đây để tải ảnh lên</span
            >
          </div>
          <input type="file" @change="onChange" />
        </div>

        <!-- -->
        <div class="my-2">
          Dung lượng tối đa là 1MB.
          <br />
          Chỉ hỗ trợ: PNG, JPEG, JPG
        </div>
        <v-card-subtitle v-if="errortext" class="pt-0 error--text">
          {{ errortext }}
        </v-card-subtitle>
      </div>
    </div>
    <template #extra-btn>
      <base-button
        v-if="img"
        class="mr-2"
        color="primary"
        text
        @click="img = null"
      >
        Xoá
      </base-button>
      <base-button v-if="img" color="primary" @click="Upload">{{
        $t('avatar.set')
      }}</base-button>
    </template>
  </base-dialog>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper'
import BaseDialog from '@/src/components/base/base-dialog.vue'

export default {
  components: {
    Cropper,
  },
  props: {
    dialog: { type: Boolean, default: false },
  },
  data: () => ({
    show: true,
    title: 'avatar',
    img: '',
    cbId: '',
    file: null,
    errortext: '',

    dragging: false,
  }),
  watch: {
    dialog: {
      handler(value) {
        this.show = value
      },
      immediate: true,
    },
    show(value) {
      if (!value) this.$emit('close')
    },
  },
  mounted() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2)
  },
  methods: {
    change({ coordinates, canvas }) {
      this.file = canvas.toDataURL()
    },
    onFileChange(e) {
      this.errortext = ''
      let img = e.target.files[0]
      if (!img) return

      if (img.size > 1 * 1024 * 1024) {
        this.errortext = 'Chỉ chập nhận tập tin dưới 1MB'
        return
      }
      let image = new Image()
      let vm = this
      image.onload = function() {
        if (this.width) {
          var reader = new FileReader()
          reader.readAsDataURL(img)
          reader.onload = (e) => {
            vm.img = e.target.result
          }
        }
      }
      image.onerror = function() {
        vm.errortext = 'Chỉ chấp nhận tập tin ảnh'
      }

      image.src = URL.createObjectURL(img)
    },
    goUpload() {
      document.getElementById(this.cbId).click()
    },
    close() {
      this.show = false
      this.$emit('close')
      this.img = ''
    },
    async Upload() {
      this.$emit('input', this.file)
      this.close()
    },
    //
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.dragging = false
        return
      }

      this.createFile(files[0])
    },
    createFile(file) {
      if (!file) return

      if (file.size > 1 * 1024 * 1024) {
        this.errortext = 'Chỉ chập nhận tập tin dưới 1MB'
        this.removeFile()
        return
      }

      this.file = file
      let image = new Image()
      let vm = this
      image.onload = function() {
        if (this.width) {
          var reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (e) => {
            vm.img = e.target.result
          }
        }
      }
      image.onerror = function() {
        vm.errortext = 'Chỉ chấp nhận tập tin ảnh'
        this.removeFile()
      }

      image.src = URL.createObjectURL(file)
      this.file = null
      this.dragging = false
    },
    removeFile() {
      this.file = ''
    },
  },

  computed: {
    extension() {
      return (this.file) ? this.file.name.split('.').pop() : '';
    }
  }
}
</script>

<style lang="scss">
.cropper {
  margin: 0 auto;
  width: 400px;
}
.dropZone {
  width: 200px;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #073430;
}

.dropZone:hover .dropZone-title {
  color: #073430;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 100px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
  color: red;
}
</style>
